/* eslint-disable arrow-parens */
import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import {
  GET_PLAID_ACCESS_GQL,
  GET_BANK_ACCOUNTS_GQL,
  UPDATE_COMPANY_CREDIT_LIMIT_GQL,
  EDIT_BANK_ACC_STATUS_GQL,
  CREATE_NEW_BANK_ACCOUNT_GQL,
  GET_BANK_BALANCE_HISTORY_GQL,
  GET_AVERAGE_BANK_BALANCE_GQL,
  GET_BANK_BALANCE_GQL,
  UPDATE_COMPANY_AVR_BANK_BALANCE_GQL,
  GET_COMPANY_AUTH_CHECK_BANK_BAL_GQL,
  GET_BANK_ACTIVE_ACCOUNT_GQL,
  EDIT_ACCOUNT_STATUS_GQL,
  EDIT_PLAID_ACCESS_GQL,
  STRIP_ACCOUNT_UPDATE,
  GET_PDF_PLAID_ID,
  GET_LINK_TOKEN_ID,
  RESET_BANK_ERROR,
  GET_LINK_TOKEN_VERIFY,
} from '@/graphql/account.gql';

export default {
  namespaced: true,

  state: {
    // = data
    setPlaidAccessToken: [],
    cmpBankAccounts: [],
    setBankAccStatus: null,
    getBankAccountBal: null,
    newAccount: [],
    updateCreditLimit: [],
    getBankBalanceHistory: [],
    getAvrBankBalance: null,
    getAvgCmpBankBal: [],
    getBankAuthBank: [],
    cmpActiveBankAccount: [],
    setBankAccountStatus: null,
    editPlaidAccessInfo: null,
    setLinkToken: null,
    setLinkTokenReconnect: null,
    setPlaidError: null,
  },

  mutations: {
    SET_PLAID_ACCESS_TOKEN(state, payload) {
      state.setPlaidAccessToken = payload;
    },
    GET_BANK_ACCOUNTS_LIST(state, payload) {
      state.cmpBankAccounts = payload;
    },
    SET_BANK_ACC_STATUS(state, payload) {
      state.setBankAccStatus = payload;
    },
    GET_BANK_BALANCE_INFO(state, payload) {
      state.getBankAccountBal = payload;
    },
    SET_NEW_BANK_ACCOUNT(state, payload) {
      state.newAccount = payload;
    },
    SET_UPDATE_COMPANY_CREDIT_LIMIT(state, payload) {
      state.updateCreditLimit = payload;
    },
    SET_BANK_BALANCE_HISTORY(state, payload) {
      state.getBankBalanceHistory = payload;
    },
    SET_AVR_BANK_BALANCE_HISTORY(state, payload) {
      state.getAvrBankBalance = payload;
    },
    SET_UPDATE_COMPANY_AVG_BALANCE(state, payload) {
      state.getAvgCmpBankBal = payload;
    },
    SET_BANK_AUTH_WITH_COMPANY(state, payload) {
      state.getBankAuthBank = payload;
    },
    GET_ACTIVE_BANK_ACCOUNT(state, payload) {
      state.cmpActiveBankAccount = payload;
    },
    SET_BANK_ACCOUNT_STATUS(state, payload) {
      state.setBankAccountStatus = payload;
    },
    EDIT_PLAID_ACCESS_DATA(state, payload) {
      state.editPlaidAccessInfo = payload;
    },
    SET_LINK_TOKEN(state, payload) {
      state.setLinkToken = payload;
    },
    SET_LINK_TOKEN_ERROR(state, payload) {
      state.setLinkTokenReconnect = payload;
    },
    SET_PLAID_ERROR(state, payload) {
      state.setPlaidError = payload;
    },
  },

  actions: {
    getPlaidAccessToken({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .mutate({
          mutation: GET_PLAID_ACCESS_GQL,
          variables: {
            public_token: payload.public_token,
            userId: payload.userId,
            companyId: payload.companyId,
            linkSessionId: payload.linkSessionId,
            institutionName: payload.institutionName,
            institutionId: payload.institutionId,
            accounts: payload.accounts,
            isCreditCard: payload.isCreditCard,
          },
        })
        .then(({ data }) => {
          commit('SET_PLAID_ACCESS_TOKEN', data.getPlaidAccessToken);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    getBankAccounts({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_BANK_ACCOUNTS_GQL,
          variables: {
            companyId: payload.companyId,
            type: payload.type,
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_BANK_ACCOUNTS_LIST', data.bankAccounts);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    updatePlaidError({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: RESET_BANK_ERROR,
          variables: {
            access_token: payload.access_token,
          },
        })
        .then(({ data }) => {
          commit('SET_PLAID_ERROR', { data: data.updatePlaidTokenError, Date: new Date() });
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    getActiveBankAccount({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_BANK_ACTIVE_ACCOUNT_GQL,
          variables: {
            companyId: payload.companyId,
            recordStatus: payload.recordStatus,
            type: payload.type,
          },
        })
        .then(({ data }) => {
          commit('GET_ACTIVE_BANK_ACCOUNT', data.bankAccounts);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },

    getBankBalHistory({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_BANK_BALANCE_HISTORY_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_BANK_BALANCE_HISTORY', data.bankBalHistories);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    getBankBalance({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: GET_BANK_BALANCE_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('GET_BANK_BALANCE_INFO', data.getBankBalance);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    createNewBankAccount({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .mutate({
          mutation: CREATE_NEW_BANK_ACCOUNT_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_NEW_BANK_ACCOUNT', data.createbankAccount);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async updateBankAccountStatus({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: EDIT_BANK_ACC_STATUS_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_BANK_ACC_STATUS', data.updateBankAccountStatus);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    updateAccountStatus({ commit }, payload) {
      console.log('updateAccountStatus');
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .mutate({
          mutation: EDIT_ACCOUNT_STATUS_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_BANK_ACCOUNT_STATUS', { data: data.updatebankAccount, time: new Date() });
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    editPlaidAccess({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .mutate({
          mutation: EDIT_PLAID_ACCESS_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('EDIT_PLAID_ACCESS_DATA', data.updateplaidAccess);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    updateCompanyCreditLimit({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .mutate({
          mutation: UPDATE_COMPANY_CREDIT_LIMIT_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_UPDATE_COMPANY_CREDIT_LIMIT', data.updateCompanyCreditLimit);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    updateCompanyAvgBalance({ commit }, payload) {
      apolloClient
        .mutate({
          mutation: UPDATE_COMPANY_AVR_BANK_BALANCE_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_UPDATE_COMPANY_AVG_BALANCE', data.updateAvrBankBalance);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    getBankAverageBalance({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_AVERAGE_BANK_BALANCE_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          let totalAvrBalance = 0;
          const BalLength = data.bankBalHistoriesAvgBalance.length / 2;

          if (data.bankBalHistoriesAvgBalance.length > 0) {
            data.bankBalHistoriesAvgBalance.forEach(balHistory => {
              totalAvrBalance += balHistory.availableBal;
            });
          }

          const avgBal = {};
          if (BalLength > 5) {
            avgBal.avgBalance = totalAvrBalance / 5;
          }
          if (BalLength > 0) {
            avgBal.avgBalance = totalAvrBalance;
          } else {
            avgBal.avgBalance = totalAvrBalance / BalLength;
          }
          commit('SET_AVR_BANK_BALANCE_HISTORY', avgBal.avgBalance);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },

    getCompanyAuthWithBank({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_COMPANY_AUTH_CHECK_BANK_BAL_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_BANK_AUTH_WITH_COMPANY', data.company);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },

    stripeAccountUpdation({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .mutate({
          mutation: STRIP_ACCOUNT_UPDATE,
          variables: {
            ...payload,
          },
        })
        .then(({ _ }) => {
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },

    fnGetLinkToken({ commit }, payload) {
      let type = 'depository';
      if (payload.isCreditCard) {
        type = 'Credit';
      }

      commit('shared/SET_LOADING', true, {
        root: true,
      });

      // Get bank Account;
      // if  4 found then change Query

      apolloClient
        .query({
          query: GET_BANK_ACCOUNTS_GQL,
          variables: {
            companyId: payload.companyId,
            type,
          },
          fetchPolicy: 'no-cache',
        })
        .then(async ({ data }) => {
          if (payload.isError === true) {
            console.log('UpdateMode of Transaction Screen');
            await apolloClient
              .query({
                query: GET_LINK_TOKEN_VERIFY,
                variables: {
                  access_token: payload.access_token,
                  ...payload,
                },
                fetchPolicy: 'no-cache',
              })
              .then((mydata) => {
                localStorage.setItem('linkTokenData', JSON.stringify(mydata.data.getLinkToken1));
                commit('SET_LINK_TOKEN_ERROR', mydata.data.getLinkToken1);
                commit('shared/SET_LOADING', false, { root: true });
              })
              .catch(err => {
                console.log(err);
                commit('shared/SET_LOADING', false, { root: true });
              });
          } else if (data.bankAccounts.length && data.bankAccounts[0].errorStatus === 'ITEM_LOGIN_REQUIRED' && data.bankAccounts[0].type === 'depository') {
            console.log('UPDATE ITEM Requied');
            payload.access_token = data.bankAccounts[0].plaidAccess.accessToken;
            await apolloClient
              .query({
                query: GET_LINK_TOKEN_VERIFY,
                variables: {
                  access_token: data.bankAccounts[0].plaidAccess.accessToken,
                  ...payload,
                },
                fetchPolicy: 'no-cache',
              })
              .then((mydata) => {
                localStorage.setItem('linkTokenData', JSON.stringify(mydata.data.getLinkToken1));
                commit('SET_LINK_TOKEN', mydata.data.getLinkToken1);
                commit('shared/SET_LOADING', false, { root: true });
              })
              .catch(err => {
                console.log(err);
                commit('shared/SET_LOADING', false, { root: true });
              });
          } else if (data.bankAccounts.length && data.bankAccounts[0].recordStatus === 4) {
            payload.access_token = data.bankAccounts[0].plaidAccess.accessToken;
            await apolloClient
              .query({
                query: GET_LINK_TOKEN_VERIFY,
                variables: {
                  access_token: data.bankAccounts[0].plaidAccess.accessToken,
                  ...payload,
                },
                fetchPolicy: 'no-cache',
              })
              .then((mydataOne) => {
                localStorage.setItem('linkTokenData', JSON.stringify(mydataOne.data.getLinkToken1));
                commit('SET_LINK_TOKEN', mydataOne.data.getLinkToken1);
                commit('shared/SET_LOADING', false, { root: true });
              })
              .catch(err => {
                console.log(err);
                commit('shared/SET_LOADING', false, { root: true });
              });
          } else {
            console.log('Else case');
            await apolloClient
              .query({
                query: GET_LINK_TOKEN_ID,
                variables: payload,
                fetchPolicy: 'no-cache',
              })
              .then((mydata) => {
                localStorage.setItem('linkTokenData', JSON.stringify(mydata.data.getLinkToken));
                commit('SET_LINK_TOKEN', mydata.data.getLinkToken);
                commit('shared/SET_LOADING', false, { root: true });
              })
              .catch(err => {
                console.log(err);
                commit('shared/SET_LOADING', false, { root: true });
              });
          }

          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },

    getTranactionHistory({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_PDF_PLAID_ID,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_BANK_AUTH_WITH_COMPANY', data.company);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },

    // createNewCreditCard({ commit }, payload) {
    //   commit('shared/SET_LOADING', true, {
    //     root: true,
    //   });
    //   apolloClient
    //     .mutate({
    //       mutation: SET_CREDIT_CARD_ACCOUNT,
    //       variables: payload,
    //     })
    //     .then(({ data }) => {
    //       // commit('SET_BANK_AUTH_WITH_COMPANY', data.company);
    //       commit('shared/SET_LOADING', false, { root: true });
    //     })
    //     .catch(err => {
    //       console.log(err);
    //       commit('shared/SET_LOADING', false, { root: true });
    //     });
    // },


  },

  getters: {
    setPlaidAccessToken: state => state.setPlaidAccessToken,
    cmpBankAccounts: state => state.cmpBankAccounts,
    setBankAccStatus: state => state.setBankAccStatus,
    getBankAccountBal: state => state.getBankAccountBal,
    newAccount: state => state.newAccount,
    updateCreditLimit: state => state.updateCreditLimit,
    getBankBalanceHistory: state => state.getBankBalanceHistory,
    getAvrBankBalance: state => state.getAvrBankBalance,
    getAvgCmpBankBal: state => state.getAvgCmpBankBal,
    getBankAuthBank: state => state.getBankAuthBank,
    cmpActiveBankAccount: state => state.cmpActiveBankAccount,
    setBankAccountStatus: state => state.setBankAccountStatus,
    editPlaidAccessInfo: state => state.editPlaidAccessInfo,
    setLinkToken: state => state.setLinkToken,
    setLinkTokenReconnect: state => state.setLinkTokenReconnect,
    setPlaidError: state => state.setPlaidError,
  },
};
